
import { defineComponent, type PropType } from 'vue';

export default defineComponent({
  name: 'LanguageInfo',
  props: {
    languages: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
});
